import React from "react";
import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import { CustomButtom } from "../../../../components/BotaoCTA/styles";

import { Wrapper, Container, TextWrap, Title, Image } from "./style";

export default function TagVeloe() {
  const scrollToOffer = () => {
    const el = document.querySelector("#plans");
    const yOffset = -80;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const { data, isLoading } = useFetchContent();
  const {
    titulo,
    titleColor,
    corDeFundo,
    corDoBotao,
    corDoTextoDoBoto,
    botao,
    tag,
  } = getSection({
    sectionName: "landingSecaoTagVeloe",
    data,
  });

  const { file, title } = tag.fields;

  if (isLoading || !data) return <Loading />;

  return (
    <Wrapper style={{ backgroundColor: corDeFundo }}>
      <Container>
        <Image src={`https://${file.url}`} alt={title} />
        <TextWrap>
          <Title color={titleColor}>{titulo}</Title>
          <CustomButtom
            className="botaoTagVeloe"
            color="primary"
            label={botao}
            onClick={scrollToOffer}
            style={{
              backgroundColor: corDoBotao,
              color: corDoTextoDoBoto,
            }}
          />
        </TextWrap>
      </Container>
    </Wrapper>
  );
}
